import { useCallback, useState } from "react";

export const useSorting = (data: any) => {
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "ascending" | "descending";
    isDate?: boolean; // Add a property to identify if the key is a date
  } | null>(null);

  const sortedData = useCallback(() => {
    let sortableItems = [...data];

    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        const { key, direction, isDate } = sortConfig;

        if (isDate) {
          // Use the original date field for sorting
          const dateA = new Date(a.date); // Access the original date
          const dateB = new Date(b.date); // Access the original date
          return direction === "ascending"
            ? dateA.getTime() - dateB.getTime()
            : dateB.getTime() - dateA.getTime();
        } else {
          // Handle other sorting logic for strings and numbers
          if (typeof a[key] === "string" && typeof b[key] === "string") {
            return direction === "ascending"
              ? a[key].localeCompare(b[key])
              : b[key].localeCompare(a[key]);
          } else {
            return direction === "ascending"
              ? a[key] - b[key]
              : b[key] - a[key];
          }
        }
      });
    }
    return sortableItems;
  }, [data, sortConfig]);

  const handleSort = (key: string, isDate: boolean = false) => {
    let direction: "ascending" | "descending" = "ascending";
    if (sortConfig && sortConfig.key === key) {
      direction =
        sortConfig.direction === "ascending" ? "descending" : "ascending";
    } else if (isDate) {
      direction = "descending"; // Set initial direction explicitly for dates
    }
    setSortConfig({ key, direction, isDate }); // Ensure isDate is updated with each click
  };

  return { sortedData: sortedData(), sortConfig, handleSort };
};
